import useAccount from "@/modules/account/hooks/useAccount";
import { useTranslation } from "react-i18next";

export default function Homepage() {
  const { t } = useTranslation();
  const { account } = useAccount();

  return (
    <div className="flex flex-col items-center justify-center flex-grow">
      <h1 className="text-3xl md:text-5xl font-bold text-gray-900 text-center">
        {t("homepage.title", {
          name: account?.first_name || account?.full_name,
        })}
      </h1>
    </div>
  );
}
